import * as storage from '@elab/core/utils/storage';
import apiUtils from '@elab/core/utils/apiUtils';

import HTTPClient from '../../utils/HTTPClient';

export const getApiService = () => `${apiUtils.getBaseUri()}/users`;
const getCurrentUserApi = () => `${getApiService()}/current`;

const acceptPrivacyPolicy = async userId => {
    const uri = `${getApiService()}/${userId}/agreements`;
    const response = await HTTPClient().postJson(uri, {
        privacyUpdateRequired: true,
    });

    if (!response.ok) {
        throw new Error(`Unable update privacy policy (${response.status})`);
    }
};

const doLoadProfile = async () => {
    const response = await HTTPClient().getNoCache(getCurrentUserApi());

    if (!response.ok) {
        throw new Error(`Unable register profile (${response.status})`);
    }
    return await response.json();
};

const getCustomerStatus = async () => {
    const url = `${getCurrentUserApi()}?fields=STATUS`;
    const response = await HTTPClient().get(url);

    if (!response.ok) {
        throw new Error(`Unable update customer status (${response.status})`);
    }
    return await response.json();
};

const getLoyaltyCheques = async () => {
    const uri = `${apiUtils.getBaseUri()}/users/current/loyalty/vouchers`;
    const response = await HTTPClient().get(uri);

    if (!response.ok) {
        throw new Error(`Unable to fetch loyalty cheques (${response.status})`);
    }

    return await response.json();
};

const clearLastViewedProducts = async url => {
    const response = await HTTPClient().get(url);

    if (!response.ok) {
        throw new Error(`Unable to clear last viewed products (${response.status})`);
    }
};

const setUserCountry = async payload => {
    const response = await HTTPClient().get(`/selectCountry?isoCode=${payload.country}`);

    storage.set('deliveryCountry', payload.country);

    if (!response.ok) {
        throw new Error('Error while trying to change country');
    }
};

export default {
    acceptPrivacyPolicy,
    doLoadProfile,
    getCustomerStatus,
    getLoyaltyCheques,
    clearLastViewedProducts,
    setUserCountry,
};
